export default "__VITE_ASSET__CpbttGGf__"